import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { fetchProjectTypesEndpoint } from 'services/projectsEndPoints';
import { IProjectTypeInfo } from 'pages/ProjectDetails/hooks/useProjectForm';
export const fetchProjectTypesThunk = createAsyncThunk('fetchProjectTypes', async () => {
  try {
    const endpoint = fetchProjectTypesEndpoint();
    const resp = await apiFetch<IProjectTypeInfo[]>(endpoint).then((res) => res?.data || null);
    return resp;
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    throw Error(message);
  }
});
